import styled from 'styled-components';
import { Button } from 'antd';

export const YAxisButton = styled(Button)`
  margin: 3px 0 3px 5px;
  padding: 5px;
`;

export const StyledTooltip = styled.div`
  a {
    padding: 4px;
    color: #1890ff;
  }
`;
